module.exports = __webpack_public_path__ + "img/ic_no_licence.7333b5db.svg";